import React from "react";
import PropTypes from "prop-types";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Switch,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio
} from "@mui/material";
import { TextField } from "@totalsoft/rocket-ui";
import { useTranslation } from "react-i18next";
import * as constants from "constants/variousTypes";

const ScoringKnockoutCriteriaListComponent = ({ knockoutCriteriaList }) => {
  const { t } = useTranslation();

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>{t("Scoring.KnockoutCriteria.Criterion")}</TableCell>
          <TableCell>{t("Scoring.KnockoutCriteria.Result")}</TableCell>
          <TableCell>{t("Scoring.KnockoutCriteria.Comment")}</TableCell>
          <TableCell>{t("Scoring.KnockoutCriteria.ApprovalType")}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {knockoutCriteriaList.map(item => (
          <TableRow key={item.scoringKnockoutCriterionId}>
            <TableCell sx={{ maxWidth: "300px" }}>{item.name}</TableCell>
            <TableCell>
              <FormControl>
                <RadioGroup row onChange={constants.emptyFunction}>
                  <FormControlLabel
                    value="true"
                    label={t("Scoring.KnockoutCriteria.Yes")}
                    control={<Radio checked={item.resultOk} disabled />}
                  />
                  <FormControlLabel
                    value="false"
                    label={t("Scoring.KnockoutCriteria.No")}
                    control={<Radio checked={!item.resultOk} disabled />}
                  />
                </RadioGroup>
              </FormControl>
            </TableCell>
            <TableCell>
              <TextField multiline maxRows={3} fullWidth value={item.comment || constants.emptyString} disabled />
            </TableCell>
            <TableCell>
              <FormControlLabel
                control={<Switch checked={item.autoApproval} disabled />}
                label={item.autoApproval ? t("Scoring.KnockoutCriteria.Auto") : t("Scoring.KnockoutCriteria.Manual")}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

ScoringKnockoutCriteriaListComponent.propTypes = {
  knockoutCriteriaList: PropTypes.array.isRequired
};

export default ScoringKnockoutCriteriaListComponent;
